export default __webpack_public_path__ + "static/media/vivo_seven.2ed096fc.webp";